import actionCreator from './action-creator';
import stateReducers from './state-reducers';
import stateSelectors from './state-selectors';

export default {
    actionCreator,
    stateReducers,
    stateSelectors
};